import { useState } from "react";

// 保護者ページスタイルの入力フィールド
export const MobileInput = ({
  type = "text",
  value,
  onChange,
  placeholder,
  label,
  disabled = false,
  maxLength,
  className = "",
}: {
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  maxLength?: number;
  className?: string;
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === "password";
  const inputType = isPasswordField && showPassword ? "text" : type;

  return (
    <div className={`w-full flex-col-el space-y-2 ${className}`}>
      {label && <label className="text-[18px] text-textcolor-black">{label}</label>}
      <div className="w-full flex-col-center relative">
        <input
          type={inputType}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full box-border py-3.5 rounded-[12px] text-[18px] transition-all duration-300 text-textcolor-black bg-white border-2 border-gray2-60 focus:border-blue-100 outline-none ${
            isPasswordField ? "px-4 pr-12" : "px-4"
          } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
          disabled={disabled}
          maxLength={maxLength}
        />
        {isPasswordField && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute bg-transparent border-none outline-none shadow-none right-3 top-1/2 transform -translate-y-1/2 p-1"
            disabled={disabled}
          >
            <span className="material-symbols-outlined text-gray2-100 text-xl">
              {showPassword ? "visibility_off" : "visibility"}
            </span>
          </button>
        )}
      </div>
    </div>
  );
};
